module.exports = __webpack_public_path__ + "static/media/simona-todorova-1HWPl4G5EE0-unsplash.68f86981.jpg";